import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { UnitValue, UnitValueControl } from 'src/app/form-controls/unit-value/unit-value.control';
import { SheetItemService } from 'src/app/services/sheet-item.service';
import { ItemTypeMetadata, SheetItemFormBase } from 'src/app/services/sheets-renderer.service';
import { Row } from 'src/app/types/aggregate-graph.types';
import { IvtfSupplementationInstructionV2 } from 'src/app/types/sheet-instruction.types';
import { InstructionsFormComponent } from '../../instructions-form/instructions-form.component';

interface IvtfSupplementationFormGroup {
	rate: FormControl<UnitValue | null>;
	totalRate: FormControl<UnitValue | null>;
	dose: FormControl<UnitValue | null>;
}

@Component({
    selector: 'app-ivtf-supplementation-item-form-v2',
    templateUrl: './ivtf-supplementation-item-form-v2.component.html',
    styleUrl: './ivtf-supplementation-item-form-v2.component.scss',
    imports: [ReactiveFormsModule, InstructionsFormComponent, UnitValueControl],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class IvtfSupplementationItemFormComponentV2 implements SheetItemFormBase, OnInit {

	@Input() instructionTypeName!: string;
	@Input() item!: Row | null;
	@Input() minDate!: string;
	@Input() maxDate!: string;
	@Input() instructionsFormArray!: FormArray;
  	@Input() itemConfig!: ItemTypeMetadata;



	constructor(private sheetItemService: SheetItemService, private formBuilder: FormBuilder) {
	}

	ngOnInit() {
		this.sheetItemService.getInstructions(this.item, this.instructionTypeName, this.itemConfig.scheduleConfig.defaultScheduleType, this.itemConfig.scheduleConfig.defaultRepeatingScheduleFrequency).forEach(instruction => {
			const group: FormGroup<IvtfSupplementationFormGroup> = this.sheetItemService.buildExistingInstructionGroup(this.instructionTypeName, instruction);
			const ivtfSupplementationInstruction = instruction as IvtfSupplementationInstructionV2;
			group.addControl('rate', this.formBuilder.control(ivtfSupplementationInstruction.rate ?? null));
			group.addControl('totalRate', this.formBuilder.control(ivtfSupplementationInstruction.totalRate ?? null));
			group.addControl('dose', this.formBuilder.control(ivtfSupplementationInstruction.dose ?? null));
			this.instructionsFormArray.push(group);
		});
	}

	addInstruction() {
		const group: FormGroup<IvtfSupplementationFormGroup> = this.sheetItemService.getNewInstructionGroup(this.instructionTypeName, this.itemConfig.scheduleConfig.defaultScheduleType, this.itemConfig.scheduleConfig.defaultRepeatingScheduleFrequency);
		group.addControl('rate', this.formBuilder.control(null));
		group.addControl('totalRate', this.formBuilder.control(null));
		group.addControl('dose', this.formBuilder.control(null));
		this.instructionsFormArray.push(group);
	}
}